export default "__VITE_ASSET__B_319UeV__"